import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { InfoIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
export function ClassicShortlist() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const total = c.shortlist.stages.length;
  return <section className="relative py-20 lg:py-28 bg-navy-50/50 overflow-hidden" data-id="element-826" data-mp="23jfs4a0rpbcg">
      <div className="absolute inset-0 pointer-events-none" data-id="element-827" data-mp="23hd3nuf9jq9u">
        <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] rounded-full bg-primary-100/20 blur-3xl hidden sm:block" data-id="element-828" data-mp="1oldojztqkpv7" />
        <div className="absolute top-0 right-0 w-[300px] h-[300px] rounded-full bg-cyan-100/15 blur-3xl hidden sm:block" data-id="element-829" data-mp="1tncunhgv20vu" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-830" data-mp="i5uvkva85pfn">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-831" data-mp="38nh63cq95e4v">
          <motion.div initial={{
          opacity: 0,
          x: -24
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.55
        }} data-id="element-832" data-mp="33ow5hc738sfw">
            <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-833" data-mp="3hmksapkpu9nl">
              {lang === 'EN' ? 'The result' : 'Результат роботи'}
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight" data-id="element-834" data-mp="3rla5w65kx7y1">
              {c.shortlist.title}
            </h2>
            <p className="mt-4 text-lg text-navy-500 leading-relaxed" data-id="element-835" data-mp="4a0trhv0rsih">
              {c.shortlist.lead}
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 24
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.55,
          delay: 0.1
        }} className="p-6 lg:p-8 rounded-2xl bg-white border border-navy-200 shadow-xl shadow-navy-200/30" data-id="element-836" data-mp="8z2bn7cgkr2">
            <div className="flex items-center gap-2 mb-6" data-id="element-837" data-mp="332og72fulk27">
              <InfoIcon className="w-3.5 h-3.5 text-navy-400" data-id="element-838" data-mp="371ni0e6a90pf" />
              <span className="text-[0.6875rem] tracking-wide uppercase text-navy-400 font-semibold" data-id="element-839" data-mp="3c1id6tx3ccga">
                {c.shortlist.demoNote}
              </span>
            </div>

            <div className="space-y-2.5" data-id="element-840" data-mp="3gubhjgondiru">
              {c.shortlist.stages.map((s, i) => {
              const width = 100 - i / total * 40;
              const isLast = i === total - 1;
              return <motion.div key={s.label} initial={{
                opacity: 0,
                x: -12
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {}} transition={{
                duration: 0.5,
                delay: 0.2 + i * 0.09
              }} style={{
                ['--bar-w' as string]: `${width}%`
              }} className={`w-full lg:w-[var(--bar-w)] flex items-baseline gap-4 px-5 py-4 rounded-xl ${isLast ? 'bg-gradient-to-r from-primary-600 to-primary-500 text-white shadow-lg shadow-primary-600/20' : 'bg-navy-50 border border-navy-200'}`} data-id="element-841" data-mp="3urzyidflg5rm" data-mpi={i}>
                    <span className={`text-2xl font-extrabold tabular-nums ${isLast ? 'text-white' : 'text-navy-900'}`} data-id="element-842" data-mp="1o1enqadrdpgd">
                      {s.value}
                    </span>
                    <span className={`text-xs leading-snug ${isLast ? 'text-white/85' : 'text-navy-500'}`} data-id="element-843" data-mp="2bu4tu2yzdeiq">
                      {s.label}
                    </span>
                  </motion.div>;
            })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}